import AddIcon from "@mui/icons-material/Add";
import { Box, Fab } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addService, changeServiceAvailability, deleteService, removeProvidedServiceById, updateProvidedServiceAvailability } from "../../../actions/providedServices";
import snackbarUtils from "../../../utils/snackbarUtils";
import ConfirmDialog from "../dialog/confirmDialog";
import ArtProvidedServiceSearchFormContainer from "./artProvidedServiceSearchFormContainer";
import ArtProvidedServiceTable from "./artProvidedServiceTable";
import ServiceFormContainer from "./serviceForm/serviceFormContainer";

const ArtProvidedServiceContainer = () => {

  const dispatch = useDispatch();
  const loadingDelete = useSelector((state) => state.providedServices.deleteService.isFetching);
  const loadingAdd = useSelector((state) => state.providedServices.addService.isFetching);
  const loadingChangeAvailability = useSelector((state) => state.providedServices.changeServiceAvailability.isFetching);

  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openServiceForm, setOpenServiceForm] = useState(false);
  const [serviceToEdit, setServiceToEdit] = useState(null);

  const handleEdit = (service) => {
    setServiceToEdit(service);
    setOpenServiceForm(true);
  }
  const handleDelete = () => {
    dispatch(deleteService(serviceToDelete.artId, serviceToDelete.prestacion, serviceToDelete.subnomenclador)).then(() => {
      dispatch(removeProvidedServiceById(serviceToDelete.prestacion, serviceToDelete.subnomenclador));
      snackbarUtils.success("Prestación eliminada correctamente");
      setServiceToDelete(null);
      setOpenDeleteDialog(false);
    })
  }

  const handleOpenDeleteDialog = (service) => {
    setServiceToDelete(service);
    setOpenDeleteDialog(true);
  }

  const handleCloseProvidedServiceForm = () => {
    setOpenServiceForm(false);
    setServiceToEdit(null);
  }
  const handleSubmitProviderServiceForm = (values) => {
    if (serviceToEdit) {
      dispatch(changeServiceAvailability(values.art, values.subnomenclador, values.prestacion, values.habilitada)).then(() => {
        snackbarUtils.success("Prestación actualizada correctamente");
        handleCloseProvidedServiceForm();
        dispatch(updateProvidedServiceAvailability(values.prestacion, values.subnomenclador, values.habilitada));
      })
    } else {
      dispatch(addService({ artId: values.art, subnomenclador: values.subnomenclador, prestacion: values.prestacion, nombrePrestacion: values.nombre, descripcionPrestacion: values.descripcion, habilitada: values.habilitada })).then(() => {
        snackbarUtils.success("Prestación agregada correctamente");
        handleCloseProvidedServiceForm();
      })
    }
  }

  return (
    <>
      <ArtProvidedServiceSearchFormContainer />
      <ArtProvidedServiceTable handleDelete={handleOpenDeleteDialog} handleEdit={handleEdit} />
      {
        <Box
          sx={{
            margin: "5px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}>
          <Fab
            onClick={() => handleEdit()}
            color="primary"
            aria-label="add">
            <AddIcon />
          </Fab>
        </Box>
      }
      <ConfirmDialog
        open={openDeleteDialog}
        handleClose={() => {
          setOpenDeleteDialog(false);
          setServiceToDelete(null);
        }}
        handleConfirm={() => handleDelete()}
        title="¿Está seguro que desea Eliminar esta prestación?"
        text={`Al hacerlo, la misma ya no será accesible para el Prestador`}
        warningText="Advertencia: Esta acción no se podrá revertir."
        loading={loadingDelete}
      />
      <ServiceFormContainer
        open={openServiceForm}
        handleSubmit={handleSubmitProviderServiceForm}
        handleClose={handleCloseProvidedServiceForm}
        serviceToEdit={serviceToEdit}
        loading={loadingAdd || loadingChangeAvailability}
      />
    </>
  )

}

export default ArtProvidedServiceContainer;